/** В данный файл пока складываю константы, которые сложно как-то отнести к какой-то категории */

/** Тип тренда */
export const TREND_STATUS = {
    positive: 'positive',
    negative: 'negative',
    neutral: 'neutral',
    /** Когда данные не получили и вернулся например null или undefined */
    empty: 'empty',
} as const;

export const TREND_SYMBOLS = {
    [TREND_STATUS.positive]: '+',
    [TREND_STATUS.negative]: '-',
    [TREND_STATUS.neutral]: '',
    [TREND_STATUS.empty]: '',
} as const;
